import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Trainers from "../pages/Trainers";
import Pricing from "../pages/Pricing";
import Gallery from "../pages/Gallery";
import Contact from "../pages/Contact";

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/despre" element={<About />} />
            <Route path="/antrenori" element={<Trainers />} />
            <Route path="/abonamente" element={<Pricing />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
        </Routes>
    );
}

export default AppRoutes;